module.exports = __webpack_public_path__ + "img/Start-Up-BW-Accelerator.00c0abdd.png";